import { ready } from '../utils/readyinit';
import initSwatchLibrary from '../sections/swatchLibrary';

ready(() => initSwatchLibrary());
